/* istanbul ignore file */

export const FORM_FIELDS = {
  EMAIL: 'email',
  AUTHORS: 'authors',
  SEARCHED_AUTHOR: 'searchedAuthor',
  SELECTED_AUTHORS: 'selectedAuthors',
  WEBSITES: 'websites',
  LANGUAGE: 'language',
};
